const actionType = {
    GET_ALL_GROUP_ITEM: 'GET_ALL_GROUP_ITEM',
    GET_EXCEPTION_ITEM: 'GET_EXCEPTION_ITEM',
    GET_EXCEPTION_LABEL_ITEM: 'GET_EXCEPTION_LABEL_ITEM',
    GET_ALL_EXCEPTION_ITEM: 'GET_ALL_EXCEPTION_ITEM',
    GET_VIEW_TREE: 'GET_VIEW_TREE',
    GET_NODE_TREE: 'GET_NODE_TREE',
    GET_FUNDS_NODE_TREE: 'GET_FUNDS_NODE_TREE',
    GET_ALL_AUTH: 'GET_ALL_AUTH',
    GET_AUDIT_RECORDS: 'GET_AUDIT_RECORDS',
    GET_ACCOUNTS_LIST: 'GET_ACCOUNTS_LIST',
    GET_REFDATA_SETTINGS: 'GET_REFDATA_SETTINGS',
    GET_HOLDING_RECON_DATA: 'GET_HOLDING_RECON_DATA',
    GET_TA_RECON_ORDERS: 'GET_TA_RECON_ORDERS',
    GET_TRANSACTION_TYPE: 'GET_TRANSACTION_TYPE',
    GET_RECON_DATE: 'GET_RECON_DATE',
};
export default actionType;
